// extracted by mini-css-extract-plugin
export default {"root":"_2s6fj","normal":"_3h2eS","tier-link":"v8Dz7","tierLink":"v8Dz7"};